(function () {
  'use strict';

  if (window.ValsoleCartChallenge) return;

  var dialogId = 'valsole-cart-security-recovery';
  var pendingIntent = null;
  var challengePattern = /(captcha|hcaptcha|recaptcha|challenge|verify(?:ing| you are human)?|cloudflare|checkpoint|security check|attention required)/i;

  function isInAppBrowser() {
    return /(Instagram|FBAN|FBAV|FB_IAB|Line\/|MicroMessenger)/i.test(navigator.userAgent || '');
  }

  function emit(surface, status) {
    var payload = {
      event: 'vs_cart_security_challenge',
      surface: String(surface || 'unknown'),
      response_status: Number(status || 0),
      in_app_browser: isInAppBrowser() ? 'yes' : 'no'
    };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    document.dispatchEvent(new CustomEvent('valsole:cart:security-challenge', { detail: payload }));
  }

  function addHidden(form, name, value) {
    if (value === undefined || value === null || value === '') return;
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = String(value);
    form.appendChild(input);
  }

  function submitIntent() {
    if (!pendingIntent || !pendingIntent.items || !pendingIntent.items.length) {
      window.location.assign((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart');
      return;
    }

    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
    var form = document.createElement('form');
    form.method = 'post';
    form.action = root + 'cart/add';
    form.hidden = true;

    if (pendingIntent.items.length === 1) {
      var item = pendingIntent.items[0];
      addHidden(form, 'id', item.id);
      addHidden(form, 'quantity', item.quantity || 1);
      Object.keys(item.properties || {}).forEach(function (key) {
        addHidden(form, 'properties[' + key + ']', item.properties[key]);
      });
    } else {
      pendingIntent.items.forEach(function (item, index) {
        addHidden(form, 'items[' + index + '][id]', item.id);
        addHidden(form, 'items[' + index + '][quantity]', item.quantity || 1);
        Object.keys(item.properties || {}).forEach(function (key) {
          addHidden(form, 'items[' + index + '][properties][' + key + ']', item.properties[key]);
        });
      });
    }
    addHidden(form, 'return_to', root + 'cart');
    document.body.appendChild(form);
    form.submit();
  }

  function ensureDialog() {
    var existing = document.getElementById(dialogId);
    if (existing) return existing;

    var wrapper = document.createElement('div');
    wrapper.id = dialogId;
    wrapper.hidden = true;
    wrapper.innerHTML =
      '<div class="vs-security-recovery__backdrop"></div>' +
      '<section class="vs-security-recovery__panel" role="alertdialog" aria-modal="true" aria-labelledby="vs-security-recovery-title" aria-describedby="vs-security-recovery-copy">' +
        '<span class="vs-security-recovery__eyebrow">SECURE CHECKOUT</span>' +
        '<h2 id="vs-security-recovery-title">Quick security check needed</h2>' +
        '<p id="vs-security-recovery-copy">Shopify paused this request before the item was added. Continue once to complete the security check and add your selected item.</p>' +
        '<button class="vs-security-recovery__continue" type="button">Continue securely</button>' +
        '<button class="vs-security-recovery__dismiss" type="button">Not now</button>' +
      '</section>';

    var style = document.createElement('style');
    style.textContent =
      '#valsole-cart-security-recovery{position:fixed;inset:0;z-index:2147483000;display:grid;align-items:end;justify-items:center;padding:16px;font-family:inherit}' +
      '#valsole-cart-security-recovery[hidden]{display:none}' +
      '.vs-security-recovery__backdrop{position:absolute;inset:0;background:rgba(6,13,32,.48);backdrop-filter:blur(4px)}' +
      '.vs-security-recovery__panel{position:relative;width:min(100%,430px);box-sizing:border-box;padding:24px;border:1px solid rgba(23,34,244,.16);border-radius:24px;background:#fff;color:#08152e;box-shadow:0 22px 70px rgba(4,12,35,.28);text-align:left}' +
      '.vs-security-recovery__eyebrow{display:inline-block;margin-bottom:10px;color:#1722f4;font-size:12px;font-weight:800;letter-spacing:.1em}' +
      '.vs-security-recovery__panel h2{margin:0 0 8px;font-size:24px;line-height:1.15}' +
      '.vs-security-recovery__panel p{margin:0 0 20px;color:#465572;font-size:15px;line-height:1.5}' +
      '.vs-security-recovery__continue,.vs-security-recovery__dismiss{width:100%;min-height:52px;border-radius:999px;font:inherit;font-weight:800;cursor:pointer}' +
      '.vs-security-recovery__continue{border:0;background:#1722f4;color:#fff;box-shadow:0 12px 26px rgba(23,34,244,.26)}' +
      '.vs-security-recovery__dismiss{min-height:44px;margin-top:6px;border:0;background:transparent;color:#435371}' +
      '.vs-security-recovery__continue:focus-visible,.vs-security-recovery__dismiss:focus-visible{outline:3px solid #edff00;outline-offset:3px}' +
      '@media(min-width:750px){#valsole-cart-security-recovery{align-items:center}.vs-security-recovery__panel{padding:28px}}';

    document.head.appendChild(style);
    document.body.appendChild(wrapper);
    wrapper.querySelector('.vs-security-recovery__continue').addEventListener('click', submitIntent);
    wrapper.querySelector('.vs-security-recovery__dismiss').addEventListener('click', function () {
      wrapper.hidden = true;
      pendingIntent = null;
    });
    return wrapper;
  }

  async function responseError(response, surface, intent) {
    if (!response) return null;
    var contentType = response.headers && response.headers.get('content-type') || '';
    var body = '';
    try {
      body = await response.clone().text();
    } catch (error) {}

    var isHtml = /text\/html|application\/xhtml/i.test(contentType) || /^\s*<!doctype html|^\s*<html/i.test(body);
    var isChallenge = response.status === 403 || (isHtml && (challengePattern.test(body) || !response.ok));
    if (!isChallenge && response.ok && isHtml) isChallenge = true;
    if (!isChallenge) return null;

    var error = new Error('Security verification required');
    error.valsoleSecurityChallenge = true;
    error.status = response.status;
    error.surface = surface || 'unknown';
    error.intent = intent || null;
    return error;
  }

  function show(error, fallbackIntent) {
    if (!error || !error.valsoleSecurityChallenge) return false;
    pendingIntent = error.intent || fallbackIntent || null;
    var dialog = ensureDialog();
    dialog.hidden = false;
    emit(error.surface, error.status);
    window.setTimeout(function () {
      var button = dialog.querySelector('.vs-security-recovery__continue');
      if (button) button.focus({ preventScroll: true });
    }, 0);
    return true;
  }

  window.ValsoleCartChallenge = {
    responseError: responseError,
    show: show,
    isChallengeError: function (error) { return Boolean(error && error.valsoleSecurityChallenge); }
  };
})();
